import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { TILE_TYPES } from '../../constants/tile-types.constant';
import { TileCreatorService } from '../../services/tile-creator.service';

@Component({
  standalone: false,
  selector: 'app-tile-creator',
  templateUrl: './tile-creator.component.html',
  styleUrls: ['./tile-creator.component.scss'],
})
export class TileCreatorComponent implements OnInit {
  @Input() tileInstance: any;

  tileTypes = TILE_TYPES.filter(({ key }) => key !== 'link-banner-b');

  tileForm: FormGroup;

  get tileTypeControl(): AbstractControl {
    return this.tileForm.get('tileType') as AbstractControl;
  }

  constructor(
    private readonly fb: FormBuilder,
    private readonly tileCreatorService: TileCreatorService,
  ) {}

  ngOnInit() {
    this.initTileForm();
  }

  private initTileForm() {
    this.tileForm = this.fb.group({
      tileType: [this.tileTypes[0].key],
    });
  }

  onTileCreate() {
    const tileType = this.tileTypeControl.value;
    this.tileCreatorService.requestTileCreate(tileType, this.tileInstance);
  }
}
